const Validation = {
  email: {
    identifier: 'email',
    rules: [
      {
        type: 'empty',
        prompt: "can't be blank",
      },
    ],
  },
  message: {
    identifier: 'message',
    rules: [
      {
        type: 'empty',
        prompt: "can't be blank",
      },
    ],
  },
};

export default Validation;
